import { render, staticRenderFns } from "./dialogHelpSwiper.vue?vue&type=template&id=40cdf6d6&scoped=true&"
import script from "./dialogHelpSwiper.vue?vue&type=script&lang=js&"
export * from "./dialogHelpSwiper.vue?vue&type=script&lang=js&"
import style0 from "./dialogHelpSwiper.vue?vue&type=style&index=0&id=40cdf6d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cdf6d6",
  null
  
)

export default component.exports